import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import React from "react";
import Mandates from "./sdd/sections/Mandates";
import MandatesWizard from "./sdd/sections/MandatesWizard";

const PageSddMandates = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'sdd.mandates' });

    return (
            <Routes>
                <Route path="/" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <Mandates/>
                    </>
                }/>
                <Route path="/wizard" element={
                    <>
                        <SectionHeader title={t('pages.wizard.header.title')} subtitle={t('pages.wizard.header.subtitle')}/>
                        <MandatesWizard type={'CREATE'}/>
                    </>
                }/>
                <Route path="/:id" element={
                    <>
                        <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                        <MandatesWizard type={'UPDATE'}/>
                    </>
                }/>
            </Routes>
    );
}

export default PageSddMandates;